// extracted by mini-css-extract-plugin
export default {"root":"IkWvl","link":"_1JBe_"};